// import { useEffect, useMemo } from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   BarElement,
//   CategoryScale,
//   LinearScale,
//   Tooltip,
//   Legend,
// } from "chart.js";

// ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

// export default function FftBarGraph2({
//   data,
//   frequneyRange,
//   setValues,
//   isNearHotspot,
// }) {
//   // 고정값: 96 kHz 샘플레이트, fftSize=1024 → Nyquist=48 kHz
//   const BIN_COUNT = 1024;
//   const STEP_HZ = 24000 / 1024;
//   const bins = data?.bins
//     ? data?.bins
//     : [];
//   // shiftBins 생성
//   const shiftBins = useMemo(() => {
//     const temp = new Array(BIN_COUNT);
//     for (let i = 0; i < BIN_COUNT; i++) {
//       temp[i] = {
//         x: (i * STEP_HZ) / 1000, // kHz 단위
//         y: Math.max(0, (bins[i] + 150) / 5), // 음수 방지 + 스케일링
//       };
//     }
//     return temp;
//   }, [bins]);

//   // bandingHz 결과
//   const { points, avgdB, peakdB, peakHz } = useMemo(
//     () => bandingHz(shiftBins, frequneyRange, isNearHotspot),
//     [shiftBins, frequneyRange]
//   );

//   useEffect(() => {
//     if (avgdB && !isNaN(avgdB)) {
//       setValues({ avgdB, peakdB, peakHz });
//     }
//   }, [avgdB, setValues]);

//   const chartData = {
//     datasets: [
//       {
//         label: "Amplitude",
//         data: points,
//         backgroundColor: "#1868db",
//         borderSkipped: false,
//       },
//     ],
//   };

//   const options = {
//     parsing: { xAxisKey: "x", yAxisKey: "y" },
//     animation: false,
//     maintainAspectRatio: false,
//     responsive: true,
//     scales: {
//       x: {
//         type: "linear",
//         min: 0,
//         max: 48,
//         title: {
//           display: true,
//           text: "Frequency (kHz)",
//           color: "#ffffff", // ← x축 타이틀 흰색
//         },
//         ticks: {
//           stepSize: 6,
//           callback: (v) => `${v} kHz`,
//           color: "#ffffff", // ← x축 눈금 흰색
//         },
//         grid: {
//           color: "rgba(255,255,255,0.1)", // ← 격자 색도 연한 흰색
//         },
//       },
//       y: {
//         min: 0,
//         max: 100,
//         title: {
//           display: true,
//           text: "Amplitude",
//           color: "#ffffff", // ← y축 타이틀 흰색
//         },
//         ticks: {
//           color: "#ffffff", // ← y축 눈금 흰색
//         },
//         grid: {
//           color: "rgba(255,255,255,0.1)", // ← 격자 색
//         },
//       },
//     },
//     plugins: {
//       legend: {
//         display: false,
//         labels: { color: "#ffffff" }, // ← 범례 흰색 (범례가 켜졌을 때)
//       },
//       tooltip: {
//         titleColor: "#ffffff", // ← 툴팁 제목 흰색
//         bodyColor: "#ffffff", // ← 툴팁 본문 흰색
//         callbacks: {
//           label: (ctx) => {
//             const { x, y } = ctx.raw || {};
//             const dbfs = typeof y === "number" ? y.toFixed(1) : y;
//             return `f: ${x?.toFixed(2)} kHz, ${dbfs} dBFS`;
//           },
//         },
//       },
//     },
//   };

//   return (
//     <div className="fftGraph2">
//       <Bar data={chartData} options={options} />
//     </div>
//   );
// }

// function bandingHz(shiftBins, frequencyRange, isNearHotspot) {
//   let startX = 0;
//   let endX = 48;
//   let multiple = 1;
//   let sum = 0;
//   let sumCnt = 0;
//   let maxY = 0;
//   let maxX = 0;

//   switch (frequencyRange) {
//     case "audible":
//       startX = 0;
//       multiple = 1;
//       endX = 10;
//       break;
//     case "gas":
//       startX = 2;
//       multiple = 5;
//       endX = 6.5;
//       break;
//     case "elec":
//       startX = 2.5;
//       multiple = 10;
//       break;
//     default:
//       startX = 0;
//       multiple = 1;
//       break;
//   }

//   let points = shiftBins.map((p) => ({ ...p })); // 그대로 사용 (곱하지 않음)

//   for (let index = 0; index < points.length; index++) {
//     points[index].x = points[index].x * multiple;
//     if (
//       points[index].x < startX * multiple ||
//       points[index].x > endX * multiple
//     ) {
//       points[index].y = 0;
//       continue;
//     }
//     if (
//       frequencyRange === "gas" &&
//       isNearHotspot &&
//       points[index].x > 19 &&
//       points[index].x < 20
//     ) {
//       points[index].y *= 1.25;
//     }

//     if (points[index].y > maxY) {
//       maxY = points[index].y;
//       maxX = points[index].x;
//     }
//     sum += points[index].y * points[index].y;
//     sumCnt++;
//   }

//   let avgdB = sumCnt > 0 ? Math.sqrt(sum / sumCnt).toFixed(1) : 0;
//   maxY = maxY.toFixed(1);
//   maxX = maxX.toFixed(1);

//   return { points, avgdB, peakdB: maxY, peakHz: maxX };
// }

import { useEffect, useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function FftBarGraph2({ data }) {
  // 고정값: 96 kHz 샘플레이트, fftSize=1024 → Nyquist=48 kHz
  const BIN_COUNT = 1024;
  const STEP_HZ = 24000 / 1024;
  const bins = data?.bins
    ? data?.bins
    : Array.from({ length: BIN_COUNT }, () => {
        return -90 + Math.random() * 70; // -90 ~ -20 범위
      });

  // shiftBins 생성
  const points = useMemo(() => {
    const temp = new Array(BIN_COUNT);
    for (let i = 0; i < BIN_COUNT; i++) {
      temp[i] = {
        x: (i * STEP_HZ) / 1000, // kHz 단위
        y: Math.max(0, (bins[i] + 150) / 5), // 음수 방지 + 스케일링
      };
    }
    return temp;
  }, [bins]);

  const chartData = {
    datasets: [
      {
        label: "Amplitude",
        data: points,
        backgroundColor: "#ffffff",
        borderSkipped: false,
      },
    ],
  };

  const options = {
    parsing: { xAxisKey: "x", yAxisKey: "y" },
    animation: false,
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        type: "linear",
        min: 0,
        max: 48,
        title: {
          display: true,
          text: "Frequency (kHz)",
          color: "#ffffff", // ← x축 타이틀 흰색
        },
        ticks: {
          stepSize: 6,
          callback: (v) => `${v} kHz`,
          color: "#ffffff", // ← x축 눈금 흰색
        },
        grid: {
          color: "rgba(255,255,255,0.2)", // ← 격자 색도 연한 흰색
        },
      },
      y: {
        min: 0,
        max: 100,
        title: {
          display: true,
          text: "Amplitude",
          color: "#ffffff", // ← y축 타이틀 흰색
        },
        ticks: {
          color: "#ffffff", // ← y축 눈금 흰색
        },
        grid: {
          color: "rgba(255,255,255,0.2)", // ← 격자 색
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        labels: { color: "#ffffff" }, // ← 범례 흰색 (범례가 켜졌을 때)
      },
      tooltip: {
        titleColor: "#ffffff", // ← 툴팁 제목 흰색~
        bodyColor: "#ffffff", // ← 툴팁 본문 흰색
        callbacks: {
          label: (ctx) => {
            const { x, y } = ctx.raw || {};
            const dbfs = typeof y === "number" ? y.toFixed(1) : y;
            return `f: ${x?.toFixed(2)} kHz, ${dbfs} dBFS`;
          },
        },
      },
    },
  };

  return (
    <div className="fftGraph2">
      <Bar data={chartData} options={options} />
    </div>
  );
}

function bandingHz(shiftBins, frequencyRange, isNearHotspot) {
  let startX = 0;
  let endX = 48;
  let multiple = 1;
  let sum = 0;
  let sumCnt = 0;
  let maxY = 0;
  let maxX = 0;

  switch (frequencyRange) {
    case "audible":
      startX = 0;
      multiple = 1;
      endX = 10;
      break;
    case "gas":
      startX = 2;
      multiple = 5;
      endX = 6.5;
      break;
    case "elec":
      startX = 2.5;
      multiple = 10;
      break;
    default:
      startX = 0;
      multiple = 1;
      break;
  }

  let points = shiftBins.map((p) => ({ ...p })); // 그대로 사용 (곱하지 않음)

  for (let index = 0; index < points.length; index++) {
    points[index].x = points[index].x * multiple;
    if (
      points[index].x < startX * multiple ||
      points[index].x > endX * multiple
    ) {
      points[index].y = 0;
      continue;
    }
    if (
      frequencyRange === "gas" &&
      isNearHotspot &&
      points[index].x > 19 &&
      points[index].x < 20
    ) {
      points[index].y *= 1.25;
    }

    if (points[index].y > maxY) {
      maxY = points[index].y;
      maxX = points[index].x;
    }
    sum += points[index].y * points[index].y;
    sumCnt++;
  }

  let avgdB = sumCnt > 0 ? Math.sqrt(sum / sumCnt).toFixed(1) : 0;
  maxY = maxY.toFixed(1);
  maxX = maxX.toFixed(1);

  return { points, avgdB, peakdB: maxY, peakHz: maxX };
}
